import { HTMLAttributes } from 'react';
import { TableRow } from '../ui/table';

export function E2NtableRow({
  children,
  ...other
}: HTMLAttributes<HTMLTableRowElement>) {
  return <TableRow {...other}>{children}</TableRow>;
}
